import axios from "utils/axios";
import { routes } from "api/routes";

export const apiGetConversations = async () => {
  const { data } = await axios.get(routes.getConversations);
  return data;
};

export const apiCreateConversation = async () => {
  const { data } = await axios.post(routes.createConversation);
  return data;
};

export const apiGetChatMessages = async (chatId) => {
  const { data } = await axios.get(routes.getChatMessages, {
    params: {
      chatId,
    },
  });
  return data;
};
